import Page from "webPage/Page";
import Ajax from "base/Ajax.js";

Page.register('page-template-tpl-static-search', () => {
    const query = Page.get_query();

    if (query.search) {
        $("#s").val(query.search);
        $(".hero h1").text("Showing search results for: " + query.search);

        updateSearchResults(query);
    }
});


async function updateSearchResults(query) {
    const $results = $(".js-search-results");

    try {
        const data = await getSearchResults(query);

        if (!data.results) {
            $results.html(
                eotwJSXFactory('div', {className: "message"}, [
                    eotwJSXFactory('p', null, ["Sorry, there are no results for your search. Please try again"])
                ]),
            );
            return;
        }

        $results.empty();
        for (let html of data.results) {
            $results.append(html);
        }

        $(".js-search-pagination").html(data.pagination);

        // Mark all the images as loaded
        $results.find(".lazyload").each((_, el) => {
            const $el = $(el);

            $el.attr("src", $el.attr("data-src"));
            $el.attr("srcset", $el.attr("data-srcset"));
            $el.addClass("loaded");
        });
    } catch (e) {
        console.warn(e);
        $results.html(
            eotwJSXFactory('div', {className: "message message--error"}, [
                eotwJSXFactory('p', null, ["Sorry, there was a problem getting your search results. Please try again later"])
            ]),
        );
    }


}

async function getSearchResults(query) {
    return Ajax.get('eotw-search', "search", query);
}
